import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import {
  getSupportedPrivacyPolicyLocaleStaticMap,
  getSupportedPrivacyPolicyLocaleDynamicMap
} from '@srca-b2b/kp5-ui-common/utils/helpers'
import Layout from 'components/Layout/Layout'
import UspPageTitle from 'components/UspPageTitle/UspPageTitle'
import { LegalDocs } from '@srca-b2b/kp5-ui-common'
import { getLegalDocsServer, getLegalDocsVersion } from '@srca-b2b/kp5-ui-common/utils/legalAPIs'
import { withOpenAccessPage } from '@srca-b2b/kp5-ui-common/utils/auth'
import dynamic from 'next/dynamic'

// Locales that have a Samsung Care Pro specific privacy policy under
// components/PrivacyPoliciesByLocale/cpro. Any other locale with "?cpro" falls back to the
// standard privacy policy for that locale.
const cproSupportedLocales = ['eu-de']

const PrivacyPolicyByLocale = ({
  staticPrivacyPolicyComponentName,
  legalDocsResponse,
  legalDocsVersions
}) => {
  let StaticPrivacyPolicyComponent = <></>
  if (staticPrivacyPolicyComponentName) {
    StaticPrivacyPolicyComponent = dynamic(() =>
      import(`../../../components/PrivacyPoliciesByLocale/${staticPrivacyPolicyComponentName}`)
    )
  }
  return (
    <Layout>
      <UspPageTitle title="Legal" />
      <Container>
        <Row>
          <Col sm={12}>
            {legalDocsResponse ? (
              <LegalDocs
                title={legalDocsResponse.data.title}
                agreements={legalDocsResponse.data}
                legalVersions={legalDocsVersions.data[0].versions}
              />
            ) : (
              <StaticPrivacyPolicyComponent />
            )}
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export const getServerSideProps = withOpenAccessPage(async ({ context, loggedInUser }) => {
  const locale = context.query.locale?.toLowerCase() || ''
  const staticPrivacyPolicyLocaleMap = getSupportedPrivacyPolicyLocaleStaticMap()
  const dynamicPrivacyPolicyLocaleMap = getSupportedPrivacyPolicyLocaleDynamicMap()
  const supportedStaticLocales = Object.keys(staticPrivacyPolicyLocaleMap)
  const supportedDynamicLocales = Object.keys(dynamicPrivacyPolicyLocaleMap)

  if (supportedStaticLocales.includes(locale)) {
    const staticPrivacyPolicyComponentName = staticPrivacyPolicyLocaleMap[locale]?.toUpperCase()
    if (staticPrivacyPolicyComponentName !== '' && staticPrivacyPolicyComponentName) {
      const props = { locale, staticPrivacyPolicyComponentName }
      if ('kaa' in context.query) {
        props.staticPrivacyPolicyComponentName = `kaa/${props.staticPrivacyPolicyComponentName}`
      } else if ('cpro' in context.query && cproSupportedLocales.includes(locale)) {
        props.staticPrivacyPolicyComponentName = `cpro/${props.staticPrivacyPolicyComponentName}`
      }
      if (loggedInUser) {
        props.loggedInUser = loggedInUser
      }
      return {
        props
      }
    }
  } else if (supportedDynamicLocales.includes(locale)) {
    const legalType = dynamicPrivacyPolicyLocaleMap[locale]
    const legalDocsResponse = await getLegalDocsServer([legalType])
    const legalDocsVersions = await getLegalDocsVersion(legalType)
    if (legalDocsResponse.statusCode === 200 && legalDocsVersions.statusCode === 200) {
      const props = { locale, legalDocsResponse, legalDocsVersions }
      if (loggedInUser) {
        props.loggedInUser = loggedInUser
      }
      return {
        props
      }
    }
  }
  // Not a supported local static or dynamic, or getLegalDocsServer error
  return {
    redirect: {
      destination: '/en/404',
      permanent: false
    }
  }
})

export default PrivacyPolicyByLocale
